import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { CMIC_FIELD_REST__NAMES } from '../../../shared/Constants';
import { checkReqCustomFields } from './utility';
import { downloadAttachmentLocally } from '../../tasks/SaveAttachment';
import { filterEmptyFields } from '../../../utility/UtilityFunctions';
import { handleLoginUserViaAuth2 } from '../../../shared/UtilityFunctions';

export const docTypeUserRole = async (userInfo, projId, docType) => {
	const URL_MADE = `${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.userRoles}/create-document-${docType}?project-uui=${projId}&onlyData=true`;

	try {
		const result = await axios.get(URL_MADE, {
			...handleLoginUserViaAuth2(userInfo),
		});
	} catch (error) {
		console.log('docTypeUserRole() Error', error);
	}
};

export const pmMedia = async userInfo => {
	const URL_MADE = `${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.PMMEDIA}?onlyData=true`;

	try {
		const result = await axios.get(URL_MADE, {
			...handleLoginUserViaAuth2(userInfo),
		});
	} catch (error) {
		console.log('pmMedia() Error', error);
	}
};

export const customFields = async (userInfo, doc) => {
	const URL_MADE = `${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.customfieldsdefinition}?limit=100&offset=0&onlyData=true&finder=selectbyobject;bindObjType=${doc.docType},bindObjSubType=${doc.docSubType}`;
	try {
		const result = await axios.get(URL_MADE, {
			...handleLoginUserViaAuth2(userInfo),
		});
		const resp = checkReqCustomFields(result.data.items);
		return resp;
	} catch (error) {
		console.log('customFields() Error', error);
		return { data: [] };
	}
};

export const sendCustomFields = async (userInfo, recordData, customFields = []) => {
	const config = {
		method: 'post',
		url: `${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.documents}/${recordData.VUuid}/custom-fields`,
		...handleLoginUserViaAuth2(userInfo),
		data: {
			CustomFields: customFields,
			ObjectId: recordData.VUuid,
			ObjectSubType: recordData.PmdTypeCode,
			ObjectType: 'PMDOCUMENT',
		},
	};
	try {
		await axios.request(config);
	} catch (error) {
		console.log('sendCustomFields() Error', error);
		return { data: [] };
	}
};

export const cfLovs = async (docData, userInfo) => {
	const URL_MADE = `${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.cflovs
		}?limit=${30}&offset=${0}&totalResults=true&onlyData=true&finder=filterbycode;cflovcode=${docData.LovCode
		},cflovFieldCode=${docData.FieldCode}`;
	try {
		const result = await axios.get(URL_MADE, {
			...handleLoginUserViaAuth2(userInfo),
		});
		result.data.items = (result?.data?.items || []).map(item => ({
			key: item.Code + item.Order,
			data: item.Value,
			label: item.Description,
		}));
		return result.data.items;
	} catch (error) {
		console.log('cfLovs() Error', error);
		return [];
	}
};

export const documentStatus = async userInfo => {
	const URL_MADE = `${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.documentstatus
		}?limit=${30}&offset=${0}&totalResults=true&onlyData=true`;
	try {
		const result = await axios.get(URL_MADE, {
			...handleLoginUserViaAuth2(userInfo),
		});

		result.data.items = (result?.data?.items || []).map(item => ({
			key: item.PmdsStatusClassCode + item.PmdsStatusCode,
			data: item.PmdsStatusCode,
			label: item.PmdsStatusName,
		}));
		return result.data.items;
	} catch (error) {
		console.log('cfLovs() Error', error);
		return [];
	}
};
export const createDocRevisionRecord = async (docData, userInfo) => {
	let data = {
		PmdrAttPath: docData.name,
		PmdrComment: docData.PmdrComment,
		PmdrContactCode: docData.PmdContactCode,
		PmdrDocOraseq: docData.PmdOraseq,
		PmdrDocVUuid: docData.VUuid,
		PmdrPartnCode: docData.PmdPartnCode,
		PmdrPartnTypeCode: docData.PmdPartnTypeCode,
		PmdrProjOraseq: docData.PmdProjOraseq,
		PmdrRevDate: new Date(),
		PmdrRevNum: docData?.revNum,
		PmdrRevUser: docData.PmdContactCode,
		VUuid: uuidv4(),
	};
	// Remove empty keys
	data = filterEmptyFields(data);

	let headers = {
		'Content-Type': 'application/vnd.oracle.adf.resourceitem+json',
	};

	if (userInfo?.isCloudUser) {
		headers.Authorization = `Bearer ${userInfo?.accessToken}`;
	}

	let config = {
		method: 'post',
		maxBodyLength: Infinity,
		url: `${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.revisions}`,
		...(userInfo?.isCloudUser
			? {}
			: {
				auth: {
					username: userInfo.username,
					password: userInfo.password,
				},
			}),
		headers: headers,
		data: data,
	};
	try {
		const result = await axios.request(config);
		return result.data;
	} catch (error) {
		console.log('createDocRevisionRecord() Error', error);
		return null;
	}
};

export const uploadRevisionDocToRecord = async (VUuid, mailData, userInfo) => {
	let data = new FormData();
	let blobData = downloadAttachmentLocally(mailData);
	data.append('revision-content-file', blobData, mailData.name);

	let config = {
		method: 'post',
		maxBodyLength: Infinity,
		url: `${userInfo.serverURL}${CMIC_FIELD_REST__NAMES.revisions}/${VUuid}`,
		...handleLoginUserViaAuth2(userInfo),
		data: data,
	};

	try {
		const result = await axios.request(config);
		if ((result.data.message = 'Revision File Upload Success')) return true;
	} catch (error) {
		console.log('uploadRevisionDocToRecord() Error', error);
		return null;
	}
};
